module.exports = __webpack_public_path__ + "Roboto-ThinItalic.588293290e86dad97fcf.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff
// module chunks = 16